export interface DropDownItem {
    id: string,
    name: string,
}

export const gradeClassList:DropDownItem[] = [
 {id: 'Freshman', name: 'Freshman'},
 {id: 'Sophomore', name: 'Sophomore'},
 {id: 'Junior', name: 'Junior'},
 {id: 'Senior', name: 'Senior'}
]

export const numMembersPerPageList: DropDownItem[] = [
    { id: '9', name: '9' },
    { id: '16', name: '16' },
     { id: '25', name: '25' },
]

export const numGamesPerPageList: DropDownItem[] = [
    { id: '8', name: '8' },
    { id: '9', name: '9' },
    { id: '10', name: '10' },
]

export const numSpecialPagesList: DropDownItem[] = [
    { id: '1', name: '1' },
    { id: '2', name: '2' },
    { id: '3', name: '3' },
    { id: '4', name: '4' },
    { id: '5', name: '5' },
    { id: '6', name: '6' },
    { id: '7', name: '7' },
    { id: '8', name: '8' },
    { id: '9', name: '9' },
    { id: '10', name: '10' },
]

export const orderByItems: DropDownItem[] = [
    { id: 'name', name: 'Name' },
    { id: 'number', name: 'Number' }
]


export const heightFeetList: DropDownItem[] = [
    { id: '', name: '' },
    { id: '4', name: '4' },
    { id: '5', name: '5' },
    { id: '6', name: '6' },
    { id: '7', name: '7' }
]

export const heightInchesList: DropDownItem[] = [
    { id: '', name: '' },
    { id: '0', name: '0' },
    { id: '1', name: '1' },
    { id: '2', name: '2' },
    { id: '3', name: '3' },
    { id: '4', name: '4' },
    { id: '5', name: '5' },
    { id: '6', name: '6' },
    { id: '7', name: '7' },
    { id: '8', name: '8' },
    { id: '9', name: '9' },
    { id: '10', name: '10' },
    { id: '11', name: '11' }
]

export const packageLevelList:DropDownItem[] = [
 {id: 'MVP', name: 'MVP'},
 {id: 'VIP', name: 'VIP'},
 {id: 'AllStar', name: 'AllStar'},
 {id: 'Partner', name: 'Partner'},
]
